import { EmptyState } from '../Kit/_index';
import { onFormatShort } from './_chartScale';

const BLOCK = 'LStudio__app_chart';

const RADIUS = 60;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/*
    🔥 DONA

    data: [{ label: 'Pagado', value: 240, tone: 'ok' }, …]

    ⚠️ SE DIBUJA CON stroke-dasharray, NO CON PATHS DE ARCO

    Un arco SVG necesita calcular seno y coseno de cada corte y elegir
    bien las banderas large-arc y sweep: es fácil equivocarse y quedan
    tajos raros al pasar la mitad. Con un círculo y dasharray, cada
    porción es "cuánto pinto" y "desde dónde arranco". Menos código y
    sin casos borde.

    ⚠️ NO MÁS DE 6 CATEGORÍAS

    Con más, las porciones quedan más finas que su etiqueta y la dona
    deja de informar. Las que sobran se agrupan en "Otros": es mejor un
    agrupado honesto que doce astillas.
*/

export const ChartDonut = ({
    data = [], size = 160, thickness = 18, centerLabel = null,
    centerValue = null, showLegend = true,
    maxSlices = 6, othersLabel = 'Otros',
    formatValue = onFormatShort, emptyLabel = 'Sin datos para graficar', ariaLabel = 'Gráfico de dona',
}) => {

    const CLEAN = data.map((d) => ({ ...d, value: Number(d.value) || 0 })).filter((d) => d.value > 0).sort((a, b) => b.value - a.value);

    const TOTAL = CLEAN.reduce((acc, d) => acc + d.value, 0);

    if (!TOTAL) return <EmptyState title={emptyLabel} size="sm" />;

    // 🔥 Agrupa la cola en "Otros"
    const SLICES = CLEAN.length > maxSlices ? [  ...CLEAN.slice(0, maxSlices - 1),
            {
                label: othersLabel,  tone: 'neutral',  value: CLEAN.slice(maxSlices - 1).reduce((acc, d) => acc + d.value, 0),
            },
        ] : CLEAN;

    let offset = 0;

    return (
        <div className={`${BLOCK}_donut`}>

            <div className={`${BLOCK}_donut__figure`} style={{ width: size, height: size }}>

                {/* 🔥 -90° arranca la primera porción arriba, no a la derecha */}
                <svg viewBox="0 0 160 160" role="img" aria-label={ariaLabel}
                    style={{ transform: 'rotate(-90deg)' }} >

                    <circle className={`${BLOCK}_donut__track`}
                        cx="80" cy="80" r={RADIUS} strokeWidth={thickness} />

                    {
                        SLICES.map((slice, index) => {

                            const PORTION = (slice.value / TOTAL) * CIRCUMFERENCE;

                            const DASH = `${PORTION} ${CIRCUMFERENCE - PORTION}`;

                            const CIRCLE = (
                                <circle  key={slice.label ?? index}  className={`${BLOCK}_donut__slice`}
                                    data-tone={slice.tone ?? 'accent'}  cx="80" cy="80" r={RADIUS}
                                    strokeWidth={thickness}   strokeDasharray={DASH}  strokeDashoffset={-offset}  >
                                    <title>
                                        {`${slice.label}: ${formatValue(slice.value)} (${Math.round((slice.value / TOTAL) * 100)}%)`}
                                    </title>
                                </circle>
                            );

                            offset += PORTION;

                            return CIRCLE;
                        })
                    }

                </svg>

                {
                    (centerLabel || centerValue) && (
                        <div className={`${BLOCK}_donut__center`}>
                            {centerValue && <strong>{centerValue}</strong>}
                            {centerLabel && <span>{centerLabel}</span>}
                        </div>
                    )
                }

            </div>

            {
                showLegend && (
                    <ul className={`${BLOCK}_donut__legend`}>
                        {
                            SLICES.map((slice, index) => (
                                <li key={slice.label ?? index} className={`${BLOCK}__legend_item`}
                                    data-tone={slice.tone ?? 'accent'} >

                                    <i className={`${BLOCK}__legend_dot`} aria-hidden="true" />

                                    <span className={`${BLOCK}_donut__legend_label`}>{slice.label}</span>

                                    <span className={`${BLOCK}_donut__legend_value`}>
                                        {Math.round((slice.value / TOTAL) * 100)}%
                                    </span>

                                </li>
                            ))
                        }
                    </ul>
                )
            }

        </div>
    );
};
